import Component from "vue-class-component";
import { TextResourceDTO } from '../model/TextResourceDTO';
import { Dictionary } from '../types/Dictionary';
import { BoIdMapping } from '../types/BoIdMapping';
import { BaseStore } from './base.store';

@Component
export class ResourceStore extends BaseStore {
	texts: Dictionary<TextResourceDTO>;

	setTexts(texts: TextResourceDTO[]) {
		this.texts = {
			...this.texts,
			...texts.reduce((texts, text) => {
				const key = this.getStoreKey(text.blockId, text.key, text.instanceType, text.instanceId);
				texts[key] = text;

				return texts;
			}, {} as Dictionary<TextResourceDTO>)
		};
	}

	getText(key: string, blockId: number, params?: any[], boIdMapping?: BoIdMapping) {
		boIdMapping = boIdMapping || this.$store.boIdMapping;

		const resource = Object.entries(boIdMapping).concat([[null, null]])
			.reduce((foundResource, [instanceType, instanceId]) => {
				const storeKey = this.getStoreKey(blockId, key, instanceType, instanceId);
				const resource = this.texts[storeKey];

				if (! foundResource || (resource && resource.order < foundResource.order)) {
					return resource;
				}

				return foundResource;
			}, null as TextResourceDTO);

		let text = resource && resource.value || "";

		if (params) {
			text = text
				// replace params
				.replace(/{([0-9]+)}/g, (match, p1) =>
					params[p1] !== undefined
						? params[p1]
						: match
				)
		}

		return text;
	}

	async fetchTexts(pageUrl: string, boIdMappings: BoIdMapping[], includeNullInstance: boolean = false) {
		const texts = await this.$resourceService.fetchTexts(pageUrl, boIdMappings, includeNullInstance);
		this.setTexts(texts);
	}

	protected getStoreKey(blockId: number, key: string, ...params: any[]) {
		return `${blockId}:${key}:${params.join(':')}`;
	}
}
